import { useMutation } from '@apollo/client';

import {
  BulkUpdateContractLineShipToCustomer,
  BulkUpdateContractLineShipToCustomerVariables
} from '@/graphql/contracts/_generated_/bulkUpdateContractLineShipToCustomer.mutation';
import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import GetBCContractLinesQuery from '@/graphql/contracts/getPaginatedFilteredBCContractLines.query.gql';
import GetPaginatedFilteredVariableContractLinesQuery from
  '@/graphql/contracts/getPaginatedFilteredVariableContractLines.query.gql';
import BulkUpdateContractLineShipToCustomerMutation
  from '@/graphql/contracts/bulkUpdateContractLineShipToCustomer.mutation.gql';
import { notificationService } from '@/services/notification/notification.client';
import {
  ALL_ITEMS
} from '@/config/common.config';
import BulkUpdateContractLineInvoiceToCustomerMutation
  from '@/graphql/contracts/bulkUpdateContractLineInvoiceToCustomer.mutation.gql';
import { BulkUpdateContractLineInvoiceToCustomer, BulkUpdateContractLineInvoiceToCustomerVariables }
  from '@/graphql/contracts/_generated_/bulkUpdateContractLineInvoiceToCustomer.mutation';

const getContractLineRefetchQueries = (contractId: UUID, toUpdateVariableLines: boolean) => {
  return [
    {
      query: GetBCContractLinesQuery,
      variables:
      {
        filter: {
          contractId: { eq: contractId }
        },
        first: ALL_ITEMS
      }
    },
    ...(toUpdateVariableLines ? [
      {
        query: GetPaginatedFilteredVariableContractLinesQuery,
        variables: {
          filter: { headerPrimaryKey: { eq: contractId } },
          first: ALL_ITEMS
        }
      },
    ] : [])
  ];
};


export function useBulkUpdateContractLineShipToInvoiceTo(contractId: UUID) {

  const [bulkShipToMutation] = useMutation
  <BulkUpdateContractLineShipToCustomer, BulkUpdateContractLineShipToCustomerVariables>(
    BulkUpdateContractLineShipToCustomerMutation,
    {
      client: apolloClientContracts,
      onError: (err) => notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger'
      }),
    },
  );

  const [bulkInvoiceToMutation] =
    useMutation<BulkUpdateContractLineInvoiceToCustomer, BulkUpdateContractLineInvoiceToCustomerVariables>(
      BulkUpdateContractLineInvoiceToCustomerMutation,
      {
        client: apolloClientContracts,
        onError: (err) => notificationService.open({
          title: 'Error',
          text: err.message,
          type: 'danger'
        }),
      },
    );

  const bulkUpdateClShipToInvoiceTo = async (
    contractLineIds: UUID[],
    shipToCustomerId: UUID | undefined,
    invoiceToCustomerId: UUID | undefined,
    purchaseOrderId: UUID | undefined,
    toUpdateVariableLines: boolean
  ) => {

    const shipToResult = shipToCustomerId ? (await bulkShipToMutation({
      variables: {
        contractLineIds,
        shipToCustomerId
      },
      awaitRefetchQueries: true,
      refetchQueries: !invoiceToCustomerId
        ? getContractLineRefetchQueries(contractId, toUpdateVariableLines)
        : []
    }))?.data?.bulkUpdateContractLineShipToCustomer : [];

    const invoiceToResult = invoiceToCustomerId ? (await bulkInvoiceToMutation({
      variables: {
        contractLineIds,
        invoiceToCustomerId,
        purchaseOrderId
      },
      awaitRefetchQueries: true,
      refetchQueries:
        getContractLineRefetchQueries(contractId, toUpdateVariableLines)
    }))?.data?.bulkUpdateContractLineInvoiceToCustomer : [];

    return {
      shipToResult,
      invoiceToResult
    };
  };

  return bulkUpdateClShipToInvoiceTo;
}